import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {DragDrop} from "@uppy/react";
import {uppyInstanceImage} from "./UppyInstanceImage";
import "@uppy/core/dist/style.css";
import "@uppy/drag-drop/dist/style.css";

export const UppyImageDragDrop = ({video_id, id, uploadType, height = 100, width, margin, onSuccess, onFail}) => {
    const token = '' //TODO remove-me;
    const [uppyInstance, setUppyInstance] = useState(null);

    useEffect(() => {
        const _uppyInstance = uppyInstanceImage({
            autoProceed: true,
            id,
            uploadType,
            video_id,
            token,
            height,
            onSuccess,
            onFail,
        });

        setUppyInstance(_uppyInstance);

        return () => setUppyInstance(null);
    }, []);

    return uppyInstance ? (
        <div style={{height, margin}}>
            <DragDrop width={width || "200px"} height={height} uppy={uppyInstance} />
        </div>
    ) : null;
};
